module.exports = __webpack_public_path__ + "img/3.c0e5f1be.png";